<template>
  <div>
    <transition name="fade-overlay">
      <div class="filter-overlay" v-if="showAdvancedFilters" :style="{'top': (90 + headerHeight) + 'px'}"></div>
    </transition>
    <section class="filter-section" id="filter-section" :style="{'top': (90 + headerHeight) + 'px'}">
      <div id="banner-overlay" v-if="isImagesavailable" @click="openOfferPage" v-bind:title="promoObj.description"></div>
      <div class="hd-container-fluid">
        <div class="filter-box">
          <a href="#" class="filter-btn" :class="{'close-advanced-search': showAdvancedFilters}" @click.prevent="showAdvancedFilters = !showAdvancedFilters;filterPackages()">
            <img v-if="!showAdvancedFilters" src="../../static/Images/filter.png" class="filter-icon" alt="filter" title="Expand filters">
            <span v-else class="close-advanced-search" title="collapse and apply filters">&times;</span>
          </a>
          <ul class="filter-menu height-transition">
            <li class="individual-filter" v-for="(filter, key) in filterPreferenceObj" :key="key">
              <a href="#" class="filter-heading" @click.prevent="showAdvancedFilters = !showAdvancedFilters;filterPackages()">
                <span :class="{'filtered': filter.filters.length > 0}">
                  {{filter.header}}
                  <span class="icon-drop">
                    <i class="icon icon-down-open"></i>
                  </span>
                  <span v-if="filter.filters.length > 0" class="filtered-apply-count">{{filter.filters.length}}</span>
                </span>
              </a>
              <transition name="advanced-filter">
                <div class="price inner-filter-ul" v-if="showAdvancedFilters">
                  <ul class="single-filter">
                    <!-- <li>
                      <button class="clear-filter" :disabled="filter.filters.length == 0" @click="clearIndividualFilter(key)">Clear
                        <i class="icon icon-reload"></i>
                      </button>
                    </li> -->
                    <li v-for="(filterObject, $index) in filter.availableOptions" :key="$index">
                      <a class="select-label">
                        <div class="checkbox-custom">
                          <input type="checkbox" :id="key + filterObject.value" :value="filterObject.value" :ref="key" :checked="filterPreferenceObj[key].filters.indexOf(filterObject.value) != -1">

                          <label :for="key + filterObject.value" @click="updateFilterObj(filterPreferenceObj[key].filters, key, $index)"></label>

                        </div>
                        <label :for="key + filterObject.value" class="check-content" v-html="filterObject.name.toLowerCase()" @click="updateFilterObj(filterPreferenceObj[key].filters, key, $index)"></label>
                      </a>
                    </li>
                  </ul>
                </div>
              </transition>
            </li>
            <button class="btn filter-reset" type="button" @click="resetFilter" v-if="showRestFilter() && !showAdvancedFilters">
              <i class="icon icon-reset"></i>
              Reset All
            </button>
          </ul>
        </div>
        <transition name="advanced-filter">
          <div class="actions" v-if="showAdvancedFilters">
            <button class="btn btn-primary" type="button" @click="showAdvancedFilters = false;filterPackages()">Done</button>
            <button class="btn btn-reset" type="button" @click="resetFilter" v-if="showRestFilter()">reset filters</button>
          </div>
        </transition>
      </div>

      <!-- <section class="compare-section-block" @click="openCompareSlideout" v-if="getShortListedPackagesLength() > 0 && !showAdvancedFilters">
        <div class="compare-section">
          <div class="compare-notification" :title="getShortListedPackagesLength() < 2 ? 'Need atleast 2 packages to compare' : ''" :style="{'cursor': getShortListedPackagesLength() < 2 ? 'auto' : 'pointer'}">
            <span class="notification-bubble" v-text="getShortListedPackagesLength()"></span>
            <img class="compare-img" src="../../static/Images/hd-compare-icon.png" alt="compare">

          </div>
        </div>
      </section> -->
    </section>

    <section class="menu-sort-component" id="menu-sort-component">
      <div class="hd-container">
        <div class="sort-packages-menu-component">
          <ul>
            <li class="allpackages">
              <a @click="filterPackages('all')" :class="{active: selectedFilterType == 'all'}" v-text="resultsCount + (resultsCount > 1 ?' Packages' : ' Package')"></a>
            </li>
            <li v-for="tourType in filterMO && filterMO.tourType" :key="tourType.name" v-if="tourType.count">
              <a @click="filterPackages(tourType.value)" v-text="tourType.value" :class="{active: selectedFilterType == tourType.value}"></a>
            </li>
            <li id="comparePackages" v-if="getShortListedPackagesLength() > 0">
              <div class="compare-container" :style="{'cursor': getShortListedPackagesLength() < 2 ? 'auto' : 'pointer'}" @click="openCompareSlideout">
                <div class="compare-info">{{getShortListedPackagesLength() > 1 ? 'Compare ' + getShortListedPackagesLength() + ' packages' : 'Add another package'}}</div>
                <button class="compare-btn" :style="{'cursor': getShortListedPackagesLength() < 2 ? 'auto' : 'pointer'}">
                  <img class="compare-img" src="../../static/Images/hd-compare-icon.png" alt="compare">
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="sort-component">
      <div class="hd-container">
        <div class="sorting-menu" v-if="resultsCount > 1">
          <p class="sortby-label">Sort by:</p>
          <ul>
            <li v-for="sortOption in sortOptions.sortsList" :key="sortOption.propName">
              <a href="#" @click.prevent="setSorting(sortOption)" :class="{'active': sortOptions.selected == sortOption.propName}">{{sortOption.name}}
                <span :style="{'visibility': sortOptions.selected == sortOption.propName ? 'visible' : 'hidden'}" class="icon" :class="{'icon-up': sortOption.ascending, 'icon-down': !sortOption.ascending}"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <loader :showLoader="displayLoader"></loader>
  </div>

</template>

<script>
import cookie from '../common/cookie'
import axios from 'axios'
import URLs from '../common/URLStore'
import loader from './loader'

export default {
  name: 'multi-filter',
  mixins: [cookie],
  props: {
    promoBannerImages: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    },
    packages: {
      // type: Array,
      required: true
    },
    filterMO: {
      // type: Object,
      required: true,
      default: function() {
        return {}
      }
    },
    outSideFilter: {
      type: Object,
      required: false,
      default: function() {
        return {}
      }
    },
    packageCompareToggled: {
      type: Number,
      required: true,
      default: function() {
        return false
      }
    },
    themeFilter: {
      default: function() {
        return null
      }
    }
  },
  components: { loader },
  data: function() {
    return {
      // disableFilterButton: true,
      resultsCount: 0,
      headerHeight: 0,
      isImagesavailable: false,
      ImageUrl: '',
      displayLoader: false,
      sortOptions: {
        selected: '',
        sortsList: {
          popularityIndex: { name: 'Popular', propName: 'popularityIndex', defaultValue: false, ascending: false },
          durationIndex: { name: 'Duration', propName: 'durationIndex', defaultValue: true, ascending: true },
          startFromPrice: { name: 'Price', propName: 'startFromPrice', defaultValue: true, ascending: true },
          launchDate: { name: 'Recently Added', propName: 'launchDate', defaultValue: false, ascending: false }
        }
      },
      showAdvancedFilters: false,
      selectedFilterType: 'all',
      packagesByTourType: [],
      filterPreferenceObj: {
        packageDuration: {
          header: 'Trip Duration',
          type: 'range',
          filters: [],
          availableOptions: [{ value: '0-3', name: 'Up to 3 Nights' }, { value: '4-6', name: '4 - 6 Nights' }, { value: '7-10', name: '7 -  10 Nights' }, { value: '11-15', name: '11 - 15 Nights' }, { value: '16-0', name: 'Above 16 Nights' }]
        },
        comfortRating: {
          header: 'Hotel Star',
          type: 'range',
          filters: [],
          availableOptions: [{ value: '4.1-5', name: '5 Star' }, { value: '3.1-4', name: '4 Star' }, { value: '0-3', name: 'Up to 3 Star' }]
        },
        travelBy: {
          header: 'Transportation',
          type: 'absolute',
          filters: [],
          availableOptions: [{ value: 'all', name: '<span class="transportation-option">All<br>Flight/Cab</span>' }, { value: 'LANDONLY', name: '<span class="transportation-option">Land only<br>By Cab</span>' }, { value: 'AIRLAND', name: '<span class="transportation-option">Flying<br>By Flight</span>' }, { value: 'AIROPTIONAL', name: '<span class="transportation-option">Optional<br>Fligth Optional</span>' }]
        },
        packageThemes: { header: 'Themes', type: 'absolute', filters: [], availableOptions: [] },
        startFromPrice: {
          header: 'Price',
          type: 'range',
          filters: [],
          availableOptions: [
            { value: '0-19999', name: 'Up to  <i class="rs">rs</i>20,000', min: 0, max: 20000 },
            { value: '20000-29999', name: '<i class="rs">rs</i>20,000 To <i class="rs">rs</i>30,000', min: 20001, max: 30000 },
            { value: '30000-39999', name: '<i class="rs">rs</i>30,000 To <i class="rs">rs</i>40,000', min: 30001, max: 40000 },
            { value: '40000-49999', name: '<i class="rs">rs</i>40,000 To <i class="rs">rs</i>50,000', min: 40001, max: 50000 },
            { value: '50000-74999', name: '<i class="rs">rs</i>50,000 To <i class="rs">rs</i>75,000', min: 50001, max: 75000 },
            { value: '75000-99999', name: '<i class="rs">rs</i>75,000 To <i class="rs">rs</i>1,00,000', min: 75001, max: 100000 },
            { value: '100000-0', name: '<i class="rs">rs</i>1,00,000 And above', min: 100001, max: 1000000 }
          ]
        }
      },
      filtersRenderData: {
        // ('[^,]*')
        startFromPrice: [
          { value: '0-19999', name: 'Up to  <i class="rs">rs</i>20000', min: 0, max: 20000 },
          { value: '20000-29999', name: '<i class="rs">rs</i>20000 To <i class="rs">rs</i>30000', min: 20001, max: 30000 },
          { value: '30000-39999', name: '<i class="rs">rs</i>30000 To <i class="rs">rs</i>40000', min: 30001, max: 40000 },
          { value: '40000-49999', name: '<i class="rs">rs</i>40000 To <i class="rs">rs</i>50000', min: 40001, max: 50000 },
          { value: '50000-74999', name: '<i class="rs">rs</i>50000 To <i class="rs">rs</i>75000', min: 50001, max: 75000 },
          { value: '75000-99999', name: '<i class="rs">rs</i>75000 To <i class="rs">rs</i>100000', min: 75001, max: 100000 },
          { value: '100000-0', name: '<i class="rs">rs</i>100000 And above', min: 100001, max: 1000000 }
        ],
        packageDuration: [{ value: '0-3', name: 'Up to 3 Nights' }, { value: '4-6', name: '4 - 6 Nights' }, { value: '7-10', name: '7 -  10 Nights' }, { value: '11-15', name: '11 - 15 Nights' }, { value: '16-0', name: 'Above 16 Nights' }],
        comfortRating: [{ value: '0-0', name: 'All' }, { value: '5.1-7', name: '7 Star' }, { value: '4.1-5', name: '5 Star' }, { value: '3.1-4', name: '4 Star' }, { value: '0-3', name: 'Up to 3 Star' }],
        travelBy: [{ value: 'all', name: 'All<br>Flight/Cab' }, { value: 'Landonly', name: 'landonly<br>By Cab' }, { value: 'Flying', name: 'Flying<br>By Flight' }, { value: 'Optional', name: 'Optional<br>Fligth Optional' }],
        packageThemes: [] // this.filterMO.packageThemes
      },
      latestFilterResult: [],
      applicableFilters: [],
      promoObj: null
    }
  },
  created: function() {
    this.headerHeight = document.getElementById('yatraFrescoHeader').offsetHeight
    if (this.themeFilter) {
      this.filterPreferenceObj.packageThemes.filters.push(this.themeFilter)
      this.filterPackages()
    }
  },
  mounted: function() {
    if (this.isImagesavailable) {
      var element = document.getElementById('menu-sort-component')
      element.style.marginTop = document.getElementById('filter-section').offsetHeight + 28 + 'px'
      axios
        .get(this.ImageUrl)
        .then(response => {
          let elem = document.getElementById('banner-overlay')
          elem.style.backgroundImage = 'url(' + this.ImageUrl + ')'
        })
        .catch(() => {
          this.isImagesavailable = false
          element.style.marginTop = 100 + 'px'
        })
    }
  },
  watch: {
    promoBannerImages: {
      handler: function(newvalue) {
        if (newvalue) {
          if (newvalue.images && newvalue.images.length && newvalue.images[0].images) {
            var images = newvalue.images[0].images
            this.promoObj = newvalue.images[0]
            if (images.cloudinaryImages && images.cloudinaryImages.length && images.cloudinaryImages[0].transformedImages && images.cloudinaryImages[0].transformedImages.holidays_banners_w_1900_h_100.url) {
              this.ImageUrl = images.cloudinaryImages[0].transformedImages.holidays_banners_w_1900_h_100.url
              if (!newvalue.images[0].targetUrl) {
                this.promoObj.targetUrl = 'www.yatra.com'
              }
              this.isImagesavailable = newvalue.isImagesAvailable
            }
          }
        }
      },
      immediate: true
    },
    showAdvancedFilters: function(newvalue) {
      var rootElement = document.getElementsByTagName('html')[0]
      if (newvalue) {
        rootElement.style.overflow = 'hidden'
      } else {
        rootElement.style.overflow = ''
      }
    },
    packageCompareToggled: function() {
      this.$forceUpdate()
    },
    outSideFilter: function(newValue) {
      this.filterPreferenceObj.startFromPrice.filters = []
      for (var i = 0; i < this.filtersRenderData.startFromPrice.length; i++) {
        var currentFilter = this.filtersRenderData.startFromPrice[i]
        if (newValue.maxPrice >= currentFilter.max) {
          this.filterPreferenceObj.startFromPrice.filters.push(currentFilter.value)
        }
      }
      this.filterPackages()
    },
    filterMO: {
      handler: function(newValue) {
        this.filtersRenderData.packageThemes = newValue.packageThemes
        this.filterPreferenceObj.packageThemes.availableOptions = newValue.packageThemes
        this.filterPreferenceObj.travelBy.availableOptions = newValue.travelBy
        // this.filterPreferenceObj.travelBy.availableOptions.unshift({ value: 'all', name: 'All' })
      },
      immediate: true
    },
    packages: {
      handler: function(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.packagesByTourType['all'] = newValue
          this.latestFilterResult = newValue

          // reset filter and sort state
          this.resetFilter()
          // this.sortOptions.selected = 'popularityIndex'
          this.setSorting(this.sortOptions.sortsList.popularityIndex)
        }
      },
      // deep: true,
      immediate: true
    }
  },
  methods: {
    openOfferPage: function() {
      if (this.isImagesavailable) {
        window.open(this.promoObj.targetUrl)
      }
    },
    setSorting: function(filter) {
      if (this.sortOptions.selected == filter.propName) {
        filter.ascending = !filter.ascending
      } else {
        this.sortOptions.selected = filter.propName
        filter.ascending = filter.defaultValue
      }
      this.sortPackages(filter)
    },
    clearIndividualFilter: function(filter) {
      this.filterPreferenceObj[filter].filters = []
    },
    showRestFilter: function() {
      for (var key in this.filterPreferenceObj) {
        if (this.filterPreferenceObj[key].filters.length > 0) {
          return true
        }
      }
      return false
    },
    openCompareSlideout: function() {
      if (this.getShortListedPackagesLength() < 2) {
        return
      }
      this.displayLoader = true
      axios
        .post(URLs.comparePackages, {
          packageIds: this.getShortListedPackages().map(pkg => pkg.packageId)
        })
        .then(resp => {
          this.displayLoader = false
          this.$emit('openslideout', {
            slideOutName: 'packagesCompare',
            props: { packagesData: resp.data.data }
          })
        })
        .catch(() => {
          this.displayLoader = false
        })
    },
    resetFilter: function() {
      for (var key in this.filterPreferenceObj) {
        this.filterPreferenceObj[key].filters = []
      }

      if (this.selectedFilterType === '') {
        this.selectedFilterType = 'all'
      }
      this.filterPackages()
    },
    sortPackages: function(sortOption) {
      var sortedPackages = []
      if (this.latestFilterResult) {
        sortedPackages = this.latestFilterResult.sort((pkg1, pkg2) => {
          return sortOption.ascending ? pkg1[sortOption.propName] - pkg2[sortOption.propName] : pkg2[sortOption.propName] - pkg1[sortOption.propName]
        })
      }
      this.resultsCount = sortedPackages.length
      this.$emit('filterChanged', { filteredPackages: sortedPackages })
    },
    filterPackages: function(tourType) {
      if (tourType) {
        this.selectedFilterType = tourType
      }

      let totalAppliedFilters = Object.keys(this.filterPreferenceObj).reduce((prev, current) => {
        return prev + this.filterPreferenceObj[current].filters.length
      }, 0)

      // first filter and store by tour type if nor already done
      if (!this.packagesByTourType[this.selectedFilterType]) {
        this.packagesByTourType[this.selectedFilterType] = this.filterPackagesByTour(this.selectedFilterType)
      }
      var that = this
      var packagesToFilter = this.packagesByTourType[this.selectedFilterType]

      if (totalAppliedFilters > 0) {
        var filteredPackages = []
        if (packagesToFilter && packagesToFilter.length > 0) {
          filteredPackages = packagesToFilter.filter(pkg => {
            for (let fltr in that.filterPreferenceObj) {
              if (that.filterPreferenceObj[fltr].filters.length > 0 && that.filterPreferenceObj[fltr].filters.indexOf('all') < 0) {
                let satisfied = false
                if (that.filterPreferenceObj[fltr].type === 'range') {
                  for (let i = 0; i < that.filterPreferenceObj[fltr].filters.length; i++) {
                    let filterRanges = that.filterPreferenceObj[fltr].filters[i].split('-').map(function(str) {
                      return Number(str)
                    })
                    if (pkg[fltr] >= filterRanges[0] && pkg[fltr] <= filterRanges[1]) {
                      satisfied = true
                      break
                    }
                  }

                  if (!satisfied) return false
                } else if (that.filterPreferenceObj[fltr].type === 'absolute') {
                  if (typeof pkg[fltr] === 'object') {
                    if (that.filterPreferenceObj[fltr].filters.some(el => pkg[fltr].indexOf(el) > -1)) {
                      satisfied = true
                    }
                  } else {
                    if (that.filterPreferenceObj[fltr].filters.indexOf(pkg[fltr]) > -1) satisfied = true
                  }

                  if (!satisfied) return false
                }
              }
            }
            return true
          })
        }

        this.latestFilterResult = filteredPackages
        this.sortPackages(this.sortOptions.sortsList[this.sortOptions.selected || 'popularityIndex'])
      } else {
        this.selectedFilterType = this.selectedFilterType ? this.selectedFilterType : 'all'
        this.latestFilterResult = packagesToFilter
        this.sortPackages(this.sortOptions.sortsList[this.sortOptions.selected || 'popularityIndex'])
      }
    },
    updateFilterObj: function(filterObj, refName, index) {
      // let refName = event.target.name
      let targetInput = this.$refs[refName][index]
      if (!targetInput.checked) {
        filterObj.push(targetInput.value)
      } else {
        filterObj.splice(filterObj.indexOf(targetInput.value), 1)
      }
    },
    filterPackagesByTour: function(tourType) {
      this.selectedFilterType = tourType
      var tmpPackages = null
      if (tourType !== 'all' && tourType !== '') {
        tmpPackages = this.packages.filter(function(pkg) {
          return pkg.tourType === tourType
        })
      } else {
        tmpPackages = this.packages
      }

      return tmpPackages
    }
  }
}
</script>

<style lang="scss">
@import '../sass/partials/variables';

$filter-transition-time: 0.2s;
.filter-section {
  z-index: 2;
}
.advanced-filter-enter,
.advanced-filter-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.advanced-filter-enter-active,
.advanced-filter-leave-active {
  transition: all $filter-transition-time ease;
}

.fade-overlay-enter,
.fade-overlay-leave-to {
  opacity: 0;
}

.fade-overlay-enter-active,
.fade-overlay-leave-active {
  transition: all $filter-transition-time ease;
}

.close-advanced-search {
  margin-top: 5px !important;
  color: black;
  span {
    font-size: 26px;
  }
}

.filter-btn {
  text-decoration: none;
}

.filter-overlay {
  position: fixed;
  height: 100%;
  top: 170px;
  z-index: 2;
  width: 100%;
  background: black;
  opacity: 0.6;
}

.transportation-option {
  display: inline-block;
  font-family: 'Rubik Regular' !important;
  padding: 0px !important;
}

.filter-heading {
  padding-left: 0px !important;
  height: 32px;
  outline: none;
}

.sticky {
  position: fixed;
  top: 0px !important;
}

.clear-filter {
  padding: 5px 10px;
  background: #fff;
  border-radius: 5px;
  width: auto !important;
  border: 1px;
  color: $color-blue !important;

  &:not(:disabled) {
    cursor: pointer;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

#comparePackages {
  float: right;
  border-radius: 5px;
  height: 45px;
  .compare-container {
    background-color: white;
    border-radius: 5px;
    position: relative;
    bottom: 8px;
    .compare-info {
      float: left;
      height: 45px;
      padding: 0px 10px;
      font-size: 12px;
      font-family: 'Rubik Medium';
      color: #666;
      text-transform: uppercase;
      line-height: 45px;
    }
    .compare-btn {
      border: none;
      background-color: #4c97ce;
      height: 45px;
      width: 45px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/multi-filter.vue